module.exports = __webpack_public_path__ + "img/1.d8913899.svg";